
export const apiUrl = process.env.API_URL
export const version = process.env.VERSION
export const cdnDomain = process.env.CDN_DOMAIN
export const termsLink = process.env.TERMS_LINK
export const policyLink = process.env.POLICY_LINK
export const educationLink = process.env.EDUCATION_URL
export const remediatorLink = process.env.REMEDIATOR_URL
export const appUrl = process.env.APP_URL

export const userTokenStorageKey = 'APP_USER_TOKEN'



// WEBPACK FOOTER //
// ./src/config.js